var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useLocation, useParams, useHistory } from 'react-router-dom';
import { useMemo } from 'react';
import { parse } from 'query-string';
import { isArray } from '../../util/isArray';
export function useRouter() {
    var location = useLocation();
    var query = useMemo(function () { return parse(location.search); }, [location]);
    var params = useParams();
    var history = useHistory();
    function extractPath(value) {
        var _a, _b, _c;
        if (isArray(value)) {
            return extractPath(value[0]);
        }
        return (_c = (_b = (_a = value === null || value === void 0 ? void 0 : value.to) !== null && _a !== void 0 ? _a : value === null || value === void 0 ? void 0 : value.route) !== null && _b !== void 0 ? _b : value === null || value === void 0 ? void 0 : value.path) !== null && _c !== void 0 ? _c : value;
    }
    function getRoute(pathLike, object) {
        if (object === void 0) { object = {}; }
        var targetPath = extractPath(pathLike);
        if (isArray(pathLike)) {
            Object.assign(object, pathLike[1]);
        }
        var $params = __assign(__assign({}, params), object);
        return Object.keys($params || {}).reduce(function (path, key) {
            if (path === void 0) { path = ''; }
            return path.replace(":" + key, ($params === null || $params === void 0 ? void 0 : $params[key]) || key);
        }, targetPath);
    }
    return {
        location: location,
        query: query,
        params: params,
        history: history,
        push: function (to) {
            history.push(getRoute(to));
        },
        isPathActive: function (to) {
            return location.pathname.startsWith(getRoute(to));
        },
        getRoute: getRoute,
        goBack: history.goBack,
    };
}
